import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


const Referral = () => {
    const { t } = useTranslation();

    const { id } = useParams(); // Get the referral ID from URL params
    const navigate = useNavigate();

    useEffect(() => {
        console.log("Referral: " + id);
         
        localStorage.setItem('referral', id);
        navigate('/');
        return
    }, [navigate]);


    return (
        <div>
            <h1> {t("redirecting")}...</h1>
        </div>
    );
};

export default Referral;